module.exports = __webpack_public_path__ + "static/img/sign-2.813d5b6f.png";